import { useState, useEffect, ReactElement } from 'react'
import styled from 'styled-components'
import { max } from 'lodash'

import { pad2 } from 'utils/string'
import { ITimerProps } from './types'

const Container = styled.div<TSFixMe>`
  color: #1976d2;
  font-size: 18px;
`

export const Timer = ({ duration, onTimeIsUp }: ITimerProps): ReactElement => {
  const [timer, setTimer] = useState(duration)

  useEffect((): TSFixMe => {
    const timerInterval = setInterval((): TSFixMe => {
      setTimer((timer: number): TSFixMe => max([timer - 1, 0]) ?? 0)
    }, 1000)

    return (): void => {
      clearInterval(timerInterval)
    }
  }, [])

  useEffect((): TSFixMe => {
    if (timer === 0) {
      onTimeIsUp()
    }
  }, [timer])

  const minutes = pad2(Math.trunc(timer / 60))
  const seconds = pad2(timer % 60)

  return (
    <Container>
      {minutes}:{seconds}
    </Container>
  )
}
